var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsArray, IsDateString, IsNumber, IsString } from "class-validator";
import { safeAssign } from "./safe-assign";
export class WorkingTimeForVenueDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForVenueDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], WorkingTimeForVenueDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForVenueDTO.prototype, "planned", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForVenueDTO.prototype, "final", void 0);
export class WorkingTimeForDepartmentDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForDepartmentDTO.prototype, "departmentId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], WorkingTimeForDepartmentDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForDepartmentDTO.prototype, "planned", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForDepartmentDTO.prototype, "final", void 0);
export class WorkingTimeForVenuesDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForVenuesDTO.prototype, "planned", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForVenuesDTO.prototype, "final", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], WorkingTimeForVenuesDTO.prototype, "venues", void 0);
export class WorkingTimeForVenueWithDepartmentsDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForVenueWithDepartmentsDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], WorkingTimeForVenueWithDepartmentsDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForVenueWithDepartmentsDTO.prototype, "planned", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForVenueWithDepartmentsDTO.prototype, "final", void 0);
__decorate([
    Expose(),
    Type(() => WorkingTimeForDepartmentDTO),
    __metadata("design:type", Array)
], WorkingTimeForVenueWithDepartmentsDTO.prototype, "departments", void 0);
export class WorkingTimeForEmployeeDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForEmployeeDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], WorkingTimeForEmployeeDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForEmployeeDTO.prototype, "planned", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForEmployeeDTO.prototype, "final", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], WorkingTimeForEmployeeDTO.prototype, "venues", void 0);
export class WorkingTimeForDepartmentsDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForDepartmentsDTO.prototype, "planned", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], WorkingTimeForDepartmentsDTO.prototype, "final", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], WorkingTimeForDepartmentsDTO.prototype, "departments", void 0);
export class GetWorkingTimeForVenuesDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber({}, { each: true }),
    __metadata("design:type", Array)
], GetWorkingTimeForVenuesDTO.prototype, "venueIds", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetWorkingTimeForVenuesDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetWorkingTimeForVenuesDTO.prototype, "to", void 0);
export class GetWorkingTimeForDepartmentsDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsArray(),
    __metadata("design:type", Array)
], GetWorkingTimeForDepartmentsDTO.prototype, "departmentIds", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetWorkingTimeForDepartmentsDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetWorkingTimeForDepartmentsDTO.prototype, "to", void 0);
export class GetWorkingTimeForEmployeeDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], GetWorkingTimeForEmployeeDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetWorkingTimeForEmployeeDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetWorkingTimeForEmployeeDTO.prototype, "to", void 0);
//# sourceMappingURL=time-reports.dto.js.map